import { render } from "./AuthenticationLayout.vue?vue&type=template&id=5a71dcbe&scoped=true"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=ts"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=ts"

import "./AuthenticationLayout.vue?vue&type=style&index=0&id=5a71dcbe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a71dcbe"

export default script